import { Navigate, Outlet } from "react-router-dom";
import { usePermissions } from "@/hooks/usePermissions";

export function PermissionGuard({ permission }: { permission: string }) {
  const { can } = usePermissions();

  if (!can(permission)) {
    return <Navigate to="/access-denied" replace />;
  }

  return <Outlet />;
}
